import api from '@/api'
import { post } from '@/api/Api'
import { ACCESS_TOKEN, APPLICATION_LOG, OPERATOR } from '@/store/mutation-types'
import { clearVue, welcome } from '@/utils/util'
import notification from 'ant-design-vue/es/notification'
import Vue from 'vue'
import { resolve } from '../../../webpack.config'

const VueCookie = require('vue-cookie')
const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
    menus: [],
    methods: [],
    operator: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_MENUS: (state, info) => {
      state.info = info
    },
    SET_METHODS: (state, info) => {
      state.info = info
    },
    // SET_OPERATOR: (state, operator) => {
    //   state.operator = operator
    // }
    SET_OPERATOR(state, operator) {
      state.operator = operator
      // 设置存储
      VueCookie.set('operator', operator, { expires: '300s' })
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        post(api.adminAuthLogin, {}, userInfo).then(response => {
          const result = response
          Vue.ls.set(ACCESS_TOKEN, result.result.token)
          Vue.ls.set(OPERATOR, result.result)
          commit('SET_OPERATOR', result.result)
          commit('SET_TOKEN', result.result.token)
          //记日志
          // new ApplicationLog().login().then(body=>{
          //   Vue.ls.set(APPLICATION_LOG,body)
          // })
          resolve(result)
        }).catch(error => {
          clearVue()
          reject(error)
        })
      })
    },
    //验证
    Verify({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        post(api.adminAuthLogin, {}, userInfo).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        const response = data.operator
        const result = {
          operator: response,
          role: {}
        }
        const role = {
          permissionList: [],
          permissions: []
        }
        if (result.operator.menus.length > 0) {
          result.operator.menus.map(per => {
            const permission = {
              permissionId: per.no,
              permissionName: per.name,
              actionEntitySet: per.methods,
              actionList: [],
              title: per.name,
              key: per.no,
              id: per.id,
              no: per.no,
              name: per.name,
              component: per.url,
              redirect: '',
              categories: []
            }
            if (per.methods != null && per.methods.length > 0) {
              permission.actionList = per.methods.map(action => {
                return action
              })
            }
            permission.categories = per.categories
            role.permissions.push(permission)
          })
          role.permissionList = role.permissions.map(permission => {
            return permission.permissionId
          })
          result.role = role
          commit('SET_ROLES', role)
          commit('SET_INFO', result)
        } else {
          notification.error({
            message: '错误',
            description: '初始化用户菜单失败，该用户未分配菜单权限!'
          })
        }
        commit('SET_NAME', { name: result.operator.name, welcome: welcome() })
        // commit('SET_AVATAR', result.avatar)
        resolve(result)
      })
    },
    // //获取用户信息
    // GetInfo ({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo().then(response => {
    //       const result = response.result
    //
    //       if (result.role && result.role.permissions.length > 0) {
    //         const role = result.role
    //         role.permissions = result.role.permissions
    //         role.permissions.map(per => {
    //           if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
    //             const action = per.actionEntitySet.map(action => { return action.action })
    //             per.actionList = action
    //           }
    //         })
    //         role.permissionList = role.permissions.map(permission => { return permission.permissionId })
    //         commit('SET_ROLES', result.role)
    //         commit('SET_INFO', result)
    //       } else {
    //         reject(new Error('getInfo: roles must be a non-null array !'))
    //       }
    //
    //       commit('SET_NAME', { name: result.name, welcome: welcome() })
    //       commit('SET_AVATAR', result.avatar)
    //
    //       resolve(response)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    Logout() {
      return new Promise((resolve) => {
        const log = Vue.ls.get(APPLICATION_LOG)
        if (log !== undefined && log !== null) {
          return post(api.adminLogLogout, 'applicationLogger', Vue.ls.get(APPLICATION_LOG))
            .then(() => {
              resolve()
            })
            .catch(() => {
              resolve()
            })
        }
      }).finally(() => {
        resolve()
      })
    }

  }
}

export default user
